import { render, staticRenderFns } from "./edit-delivery-zone.vue?vue&type=template&id=c97d9bb6&"
import script from "./edit-delivery-zone.vue?vue&type=script&lang=js&"
export * from "./edit-delivery-zone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports